<action-bar>
  <div class="subnav">
    <div class="links">
      <a [routerLink]="['/control-reports/notifications']" routerLinkActive="active" translate>Notifications</a>
    </div>
  </div>
</action-bar>